import { GenerateModalWithSuspense } from "@libs/modal-panels/modal-registry-helpers";
import { iModalProps } from "@libs/modal-panels/modal-registry-model";
import React from "react";

const ImportQCRuleGroupsModal = React.lazy(
  () => import("./import-qc-rule-groups.modal"),
);

const ImportQCRuleGroups: iModalProps<
  typeof ImportQCRuleGroupsModal,
  {
    onImported?: () => void;
  }
> = {
  name: "import-qc-rule-groups",
  component: GenerateModalWithSuspense(ImportQCRuleGroupsModal),
};

export default ImportQCRuleGroups;
